import { render, staticRenderFns } from "./FixedBtn.vue?vue&type=template&id=dd61af22&"
import script from "./FixedBtn.vue?vue&type=script&lang=js&"
export * from "./FixedBtn.vue?vue&type=script&lang=js&"
import style0 from "./FixedBtn.vue?vue&type=style&index=0&id=dd61af22&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports